/**
 * Hero background shader: "ink flow + grain".
 * Thin wrapper over the shared shader core. Uses the default params merged with
 * any override the shader lab saved for this browser (see /shader-lab.html).
 */

import { createInkShader, loadHeroParams } from './shader-core.js';

export function initHeroShader() {
  const canvas = document.getElementById('heroShader');
  if (!canvas) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const params = loadHeroParams();

  createInkShader(canvas, {
    getParams: () => params,
    reduce,
    renderScale: 0.7
  });
}
